import { Component, OnInit } from '@angular/core';

import { VehicleInfo } from 'src/app/models/vehicle-info';
import { BadaService } from 'src/app/services/bada.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  vehicleInfo: VehicleInfo;

  constructor(private badaService: BadaService) { }

  ngOnInit(): void {
    /**
     * Sottoscrizione al cambiamento delle vehicleInfo
     */
    this.badaService.vehicleInfo.subscribe(vehicleInfo => {
      this.vehicleInfo = vehicleInfo;
    })
  }

}
